<template>
    <div :id="id" class="modal tw2-bg-black tw2-bg-opacity-50" v-bind:class="{'is-active': open }">
        <div class="modal-dialog" role="document">
            <div class="modal-content tw-rounded-md tw-shadow-lg tw-border-none tw-max-w-128">
                <div v-if="state != 'success'" class="modal-header tw-border-none tw-px-8 tw-pt-8">
                    <div>
                        <h5 class="modal-title tw-font-bold tw-text-xl tw-text-theme-secondary">{{ title }}</h5>
                        <h6 class="modal-title tw-font-semibold tw-text-md tw-text-theme-secondary-light tw-leading-tight">{{ subtitle }}</h6>
                    </div>
                    <button v-on:click="closeModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body tw-relative tw-min-h-32 tw-px-8">
                    <div v-if="state == 'loading'">
                        <div class="tw-absolute tw-pin tw-flex tw-items-center tw-justify-center tw-opacity-100">
                            <div class="spinner">
                                <div></div>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="state == 'pn_form'">
                        <p v-if="phone != phone_number" class="tw-text-theme-secondary tw-py-2 tw-px-1">The new Phone Number will be saved to your Cherry™ Account.</p>
                        <input v-model="phone" type="number" class="tw-w-full tw-h-16 tw-border-theme-secondary-lightest tw-border-2 tw-rounded tw-py-2 tw-px-4 tw-text-center tw-text-3xl tw-text-theme-secondary" />
                        <p v-if="error" class="tw-text-theme-secondary tw-px-1 tw-text-red">{{ error }}</p>
                        <p v-if="$v.phone.$error" v-text="getInputValidationMessages('phone', 'Phone Number')[0]" class="tw2-px-1 tw2-text-red-700"></p>
                        <div class="tw-w-full tw-text-center tw-py-8">
                            <div class="tw-flex tw-justify-center">
                                <button v-on:click.prevent="validateForm('sms')" class="tw-py-2 tw-px-4 tw-mx-2 button-primary-inverted tw-w-64 tw-text-lg">Get code by SMS</button>
                                <button v-on:click.prevent="validateForm('ivr')" class="tw-py-2 tw-px-4 tw-mx-2 button-primary-inverted tw-w-64 tw-text-lg">Get code by Call</button>
                            </div>
                            <a v-on:click.prevent="has_code" class="tw-block tw-text-theme-secondary hover:tw-text-theme-secondary-darkest tw-text-sm tw-underline tw-mt-2" href="#">I have a code</a>
                        </div>
                    </div>
                    <div v-else-if="state == 'cd_form'">
                        <div class="tw-flex tw-justify-center">
                            <div v-for="(code, index) in codes" :key="index">
                                <input v-on:input="input" v-model="codes[index]" :key="index" :id="'code_' + index" class="tw-w-16 tw-h-16 tw-border-theme-secondary-lighter tw-border-2 tw-rounded tw-mx-1 tw-py-2 tw-px-4 tw-text-center tw-text-3xl tw-text-theme-secondary">
                            </div>
                        </div>
                        <p v-if="error" class="tw-text-theme-secondary tw-p-1 tw-text-red tw-text-center">{{ error }}</p>

                        <div class="tw-w-full tw-text-center tw-py-8">
                            <button v-on:click="cd_form_submitted" class="tw-my-4 tw-py-3 tw-px-16 button-primary-inverted tw-w-64 tw-text-lg">Validate</button>
                            <div class="tw-flex tw-justify-center tw-items-center">
                                <a v-on:click.prevent="change_number" class="tw-block tw-text-theme-secondary hover:tw-text-theme-secondary-darkest tw-text-sm tw-underline" href="#">Change number</a>
                                <span class="tw-px-4">&#8212;</span>
                                <a v-on:click.prevent="resend_code" class="tw-block tw-text-theme-secondary hover:tw-text-theme-secondary-darkest tw-text-sm tw-underline" href="#">Resend code</a>
                            </div>
                        </div>
                    </div>
                    <div v-else-if="state == 'success'">
                        <div class="tw-flex-col tw-justify-center tw-items-center tw-text-center tw-min-h-32">
                            <p class="tw-text-theme-primary tw-text-xl tw-font-bold tw-p-8 tw-leading-tight">You phone number has been successfully validated</p>
                            <div class="tw-py-4">
                                <a class="tw-block tw-text-theme-secondary hover:tw-text-theme-secondary-darkest tw-text-sm tw-underline" href="/dashboard">Back to your account</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { FormValidationMixin } from '../../mixins/validation.mixin'
import { required, minLength } from 'vuelidate/lib/validators'
import { ErrorHandlerMixin } from '../../mixins/error-handler.mixin'

const pn_form = {
    title: 'SMS Verification',
    subtitle: 'Some account features are restricted until you validate your phone number',
};

const cd_form = {
    title: 'Enter the 6 digit OTP',
    subtitle: 'A 6 digit one time password has been sent to your phone number registered to your account',
};

export default {
    mixins: [ FormValidationMixin, ErrorHandlerMixin ],
    props: ['id', 'open', 'phone_number', 'close'],
    data() {
        return {
            error: '',
            title: '',
            subtitle: '',
            phone: null,
            old_phone: undefined,
            state: 'pn_form', // pn_form, loading, cd_form, success,
            codes: ['', '', '', '', '', ''],
            channel: null,
        };
    },
    validations: {
        phone: { required, minLength: minLength(10) },
    },
    mounted: function () {
        this.old_phone = +this.phone_number
        this.title = pn_form.title;
        this.subtitle = pn_form.subtitle;
        this.phone = +this.phone_number;
    },
    methods: {
        pn_form_submitted: function () {
            let changed = +this.phone !== +this.phone_number;

            changed ? this.update_phone_number() : this.get_sms_code();
        },
        cd_form_submitted: function () {
            console.log('cd_form submited');
            this.set_state('loading');

            let success_response = false;

            axios.post('/account/verify', { code: this.codes.join('') })
                .then(response => {
                    console.log(response.status)
                    if (response.status == 200) {
                        this.set_state('success');
                    }
                })
                .catch(_error => {
                    this.error = this.errorHandlerResult(_error).message;
                    this.set_state('cd_form', false);
                })
        },
        input: function (event) {
            let id = event.target.id;
            let index = +(id.substr(id.length - 1));
            let values = '1234567890';

            if (event.target.value.length > 1) {
                this.codes[index] = event.target.value.substr(event.target.value.length - 1, 1);
            }

            if (values.indexOf(this.codes[index]) < 0) {
                console.log('invalid char');
                this.codes[index] = '';
                return;
            }

            if (index < 5 && this.codes[index] != '' && this.codes[index].length == 1) {
                document.getElementById('code_' + (index + 1)).focus();
            } else if (index == 5  && this.codes[index].length > 1) {
                this.codes[index] = this.codes[index].substr(this.codes[index].length - 1, 1);
            }
        },
        update_phone_number: function () {
            this.request_code();
        },
        request_code: function () {
            this.set_state('loading');

            let success_response = false;

            axios.patch('/account', { phone: this.phone, channel: this.channel })
                .then(response => {
                    console.log(response.status)
                    if (response.status == 200) {
                        this.set_state('cd_form');
                        this.old_phone = this.phone
                    }
                })
                .catch(_error => {
                    this.error = this.errorHandlerResult(_error).message;
                    this.set_state('pn_form', false);
                })
        },
        has_code: function () {
            this.set_state('cd_form');
        },
        change_number: function () {
            this.set_state('pn_form');
        },
        resend_code: function () {
            console.log('resending code');
            this.request_code();
        },
        set_state: function (state, override_errors = true) {
            if (override_errors) {
                this.error = null;
            }

            switch (state) {
                case 'pn_form':
                    this.title = pn_form.title;
                    this.subtitle = pn_form.subtitle;
                    break;
                case 'cd_form':
                    this.title = cd_form.title;
                    this.subtitle = cd_form.subtitle;
                    break;
            }

            this.state = state;

            Vue.nextTick(function () {
                if (document.getElementById('code_0')) {
                    document.getElementById('code_0').focus();
                }
            });
        },
        get_sms_code: function () {
            this.request_code();
        },
        validateForm (channel) {

            this.$v.$touch();

            if (!this.$v.$invalid) {
                this.channel = channel;
                this.pn_form_submitted();
            }

        },
        closeModal () {
            this.phone = this.old_phone
            this.$emit('close');
        }
    }
}
</script>
